/**
 * SAIT-22, 06.10.2026: один скрипт ReviewLab на всю SPA-сессию.
 * Повторные монтирования используют тот же Promise; после ошибки можно повторить.
 */
const SCRIPT_URL = 'https://app.reviewlab.ru/widget/index-es2015.js';
const ELEMENT_NAME = 'review-lab';
// Ограничиваем ожидание скрипта: недоступный сервис не оставляет вечную загрузку.
const SCRIPT_TIMEOUT_MS = 20000;
let loading = null;

export function loadReviewLab() {
    if (!window.customElements) {
        return Promise.reject(new Error('ReviewLab: браузер не поддерживает custom elements'));
    }
    if (window.customElements.get(ELEMENT_NAME)) {
        return Promise.resolve();
    }
    if (loading) {
        return loading;
    }

    loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        let timeout;
        let settled = false;
        const finish = (error = null) => {
            if (settled) {
                return;
            }
            settled = true;
            clearTimeout(timeout);
            script.onload = null;
            script.onerror = null;
            if (error) {
                script.remove();
                reject(error);
            } else {
                resolve();
            }
        };

        script.src = SCRIPT_URL;
        script.async = true;
        script.onload = () => {
            // Провайдер может зарегистрировать элемент асинхронно после выполнения скрипта.
            window.customElements.whenDefined(ELEMENT_NAME).then(() => finish());
        };
        script.onerror = () => finish(new Error('ReviewLab: скрипт недоступен'));
        timeout = setTimeout(() => finish(new Error('ReviewLab: время ожидания истекло')), SCRIPT_TIMEOUT_MS);
        document.head.appendChild(script);
    }).catch((error) => {
        loading = null;
        throw error;
    });

    return loading;
}
